import React from 'react';
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from 'recharts';

import LegendWithPercentage from './components/LegendWithPercentage';

export default function CriteriumPieChart ({
  chartData,
  chartOptions,
  colors
}: {
  chartData: {
    data: any
  }
  chartOptions: {
    width: string | number
    height: number
  }
  colors: string[]
}) {
  const { data } = chartData;
  return (
    // using width 99% to make container resize properly https://github.com/recharts/recharts/issues/172#issuecomment-307858843
    <ResponsiveContainer {...chartOptions} minWidth={300}>
      <PieChart>
        <Legend
          verticalAlign='middle'
          align='right'
          layout='vertical'
          content={<LegendWithPercentage />}
        />
        <Pie
          data={data}
          dataKey='value'
          cx='50%'
          innerRadius='50%'
          startAngle={90}
          endAngle={-270}
          isAnimationActive={false}
        >
          {
            data.map((_: any, i: number) => <Cell key={i} fill={colors[i % colors.length]} />)
          }
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}
